export class MoratoriumMessageDTO {
  Message: string
}
